import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import CONFIG from "../config";
import "./Kitoblar.css";
import { FaUser, FaCalendarAlt, FaLayerGroup, FaInfoCircle, FaSearch, FaTimes, FaBookOpen, FaDownload } from "react-icons/fa";

function Kitoblar() {
    const [books, setBooks] = useState([]);
    const [filteredBooks, setFilteredBooks] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [loading, setLoading] = useState(true);
    const [selectedBook, setSelectedBook] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        fetch(`${CONFIG.API_BASE_URL}/kitoblar.php`)
            .then(r => r.json())
            .then(res => {
                if (res.status === 'success') {
                    setBooks(res.data);
                    setFilteredBooks(res.data);
                }
            })
            .catch(err => console.error("Books load error:", err))
            .finally(() => setLoading(false));
    }, []);

    const handleSearch = (term) => {
        setSearchTerm(term);
        const lowerTerm = term.toLowerCase();
        const filtered = books.filter(book =>
            book.nomi.toLowerCase().includes(lowerTerm) ||
            book.muallif.toLowerCase().includes(lowerTerm) ||
            book.izoh.toLowerCase().includes(lowerTerm) ||
            book.yil.toString().includes(lowerTerm) ||
            (book.bolim && book.bolim.toLowerCase().includes(lowerTerm))
        );
        setFilteredBooks(filtered);
    };

    const handleDetail = (book) => {
        setSelectedBook(book);
    };

    return (
        <div className="kitob-quti">
            <div className="kitob-top-bar">
                <h1 className="kitob-header">Dasturlashga oid kitoblar</h1>
                <div className="kitob-search-wrapper">
                    <form className="kitob-search-form" onSubmit={(e) => e.preventDefault()}>
                        <FaSearch className="search-icon" />
                        <input
                            type="text"
                            placeholder="Kitob qidirish..."
                            value={searchTerm}
                            onChange={(e) => handleSearch(e.target.value)}
                        />
                    </form>
                </div>
            </div>

            {loading ? (
                <div className="kitob-loading">Yuklanmoqda...</div>
            ) : (
                <div className="kitob-grid">
                    {filteredBooks.map((book) => (
                        <BookCard key={book.id} book={book} onRead={() => handleDetail(book)} />
                    ))}
                </div>
            )}

            {selectedBook && (
                <BookModal book={selectedBook} onClose={() => setSelectedBook(null)} />
            )}
        </div>
    );
}

function BookModal({ book, onClose }) {
    if (!book) return null;

    return (
        <div className="book-modal-overlay" onClick={onClose}>
            <div className="book-modal-content" onClick={(e) => e.stopPropagation()}>
                <button className="book-modal-close" onClick={onClose}>
                    <FaTimes />
                </button>

                <div className="book-modal-body">
                    <div className="book-modal-header">
                        <h2 className="modal-book-title">{book.nomi}</h2>
                        <div className="modal-book-author">
                            <FaUser className="modal-icon" />
                            <span>{book.muallif}</span>
                        </div>
                    </div>

                    <div className="book-modal-top-section">
                        <div className="book-modal-img-box">
                            <div className="modal-book-3d">
                                <div className="modal-book-front">
                                    <img
                                        src={`/${book.rasm}`}
                                        alt={book.nomi}
                                        onError={(e) => {
                                            e.target.onerror = null;
                                            e.target.src = "https://via.placeholder.com/300x400?text=Kitob+Muvovasi";
                                        }}
                                    />
                                </div>
                                <div className="modal-book-spine"></div>
                            </div>
                        </div>
                        <div className="book-modal-info-box">
                            <div className="modal-info-grid">
                                <div className="modal-info-item">
                                    <FaCalendarAlt className="modal-icon" />
                                    <div>
                                        <label>Nashr yili</label>
                                        <span>{book.yil}-yil</span>
                                    </div>
                                </div>
                                <div className="modal-info-item">
                                    <FaLayerGroup className="modal-icon" />
                                    <div>
                                        <label>Bo'lim</label>
                                        <span>{book.bolim}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="book-modal-bottom-section">
                        <div className="modal-description">
                            <div className="modal-desc-header">
                                <FaInfoCircle className="modal-icon" />
                                <h3>Kitob haqida</h3>
                            </div>
                            <p>{book.izoh}</p>
                        </div>

                        <div className="modal-actions">
                            <button className="modal-btn-read">
                                <FaBookOpen />
                                Mutolaa qilish
                            </button>
                            <button className="modal-btn-download">
                                <FaDownload />
                                Yuklab olish
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

function BookCard({ book, onRead }) {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <div className="kitob-card-container" onMouseLeave={() => setIsOpen(false)}>
            <div className="kitob-floating-wrapper">
                <div className={`kitob-book ${isOpen ? 'is-open' : ''}`} onClick={() => setIsOpen(!isOpen)}>
                    <div className="book-cover">
                        <div className="book-front">
                            <img
                                src={`/${book.rasm}`}
                                alt={book.nomi}
                                onError={(e) => {
                                    e.target.onerror = null;
                                    e.target.src = "https://via.placeholder.com/300x400?text=Kitob+Muvovasi";
                                }}
                            />
                            <div className="kitob-views-badge">👁️ {book.likes}</div>
                        </div>
                    </div>
                    <div className="book-pages">
                        <div className="book-inside-content">
                            <div className="book-inside-title">{book.nomi}</div>
                            <div className="book-inside-details">
                                <div className="inside-item">
                                    <FaUser className="inside-icon" />
                                    <span>{book.muallif}</span>
                                </div>
                                <div className="inside-item">
                                    <FaCalendarAlt className="inside-icon" />
                                    <span>{book.yil}-yil</span>
                                </div>
                                <div className="inside-item">
                                    <FaLayerGroup className="inside-icon" />
                                    <span>{book.bolim}</span>
                                </div>
                                <div className="inside-item izoh-item">
                                    <FaInfoCircle className="inside-icon" />
                                    <p className="book-inside-izoh">{book.izoh}</p>
                                </div>
                                <div
                                    className="book-inside-btn"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        onRead();
                                    }}
                                >
                                    O'qish →
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="book-back"></div>
                    <div className="book-spine"></div>
                </div>
            </div>
        </div>
    );
}

export default Kitoblar;
